import {createSelector} from '@reduxjs/toolkit'
import { 
    COLLECTOR_AGENCY_ADDITIONAL_BRANCH_FEES_CAD, 
    COLLECTOR_AGENCY_FEES_CAD, 
    COLLECTOR_FEES_CAD 
} from '../../app/constants'

const paymentPreviewSelector = createSelector(
    [state => state.components, 
    state => state.primaryAgencyApplication,
    state => state.additionalApplications],
    (components, primaryApplication, additionalApplications) => {
        
        let collectionAgencyFees = {
            agencyFees : COLLECTOR_AGENCY_FEES_CAD,
            agencyRenewalFees: 0,
            additionalBranchFees : COLLECTOR_AGENCY_ADDITIONAL_BRANCH_FEES_CAD,
            agentFees : COLLECTOR_FEES_CAD,
            agentRenewalFees : 0
        }

        let debtManagementAgencyFees = {
            agencyFees : COLLECTOR_AGENCY_FEES_CAD,
            agencyRenewalFees: 0,
            additionalBranchFees : COLLECTOR_AGENCY_ADDITIONAL_BRANCH_FEES_CAD,
            agentFees : COLLECTOR_FEES_CAD,
            agentRenewalFees : 0
        }

        let mortgageAgencyFees = {
            brokerFees : 0,
            brokerRenewalFees : 0,
            associateBrokerFees : 0,
            associateBrokerRenewalFees : 0,
            brokerageFees : 0,
            brokerageRenewalFees : 0,
            lenderFees : 0,
            lenderRenewalFees : 0,
            administratorFees : 0,
            administratorRenewalFees : 0,
            associateBrokerTransferFees:0,
            brokerTransferFees:0
        }

        let mortgageMainAgentApplicationFees = {
            brokerageFees : 0,
            brokerageRetentionFees : 0,
        }

        primaryApplication.referenceData?.feeDataList?.forEach((fee) => {
            if(fee.name === "COLLECTION_AGENCY_APPLICATION_LICENCE_FEE") {
                collectionAgencyFees.agencyFees = fee.value
            } else if(fee.name === "COLLECTION_AGENCY_RENEWAL_LICENCE_FEE") {
                collectionAgencyFees.agencyRenewalFees = fee.value
            } else if(fee.name === "COLLECTION_AGENCY_ADDITIONAL_BRANCHES_FEE") {
                collectionAgencyFees.additionalBranchFees = fee.value
            } else if(fee.name === "COLLECTOR_LICENCE_APPLICATION_FEE") {
                collectionAgencyFees.agentFees = fee.value
            } else if (fee.name === "COLLECTOR_LICENCE_RENEWAL_FEE") {
                collectionAgencyFees.agentRenewalFees = fee.value
            } else if(fee.name === "DEBT_MANAGEMENT_APPLICATION_LICENCE_FEE") {
                debtManagementAgencyFees.agencyFees = fee.value
            } else if(fee.name === "DEBT_MANAGEMENT_RENEWAL_LICENCE_FEE") {
                debtManagementAgencyFees.agencyRenewalFees = fee.value
            } else if(fee.name === "DEBT_MANAGEMENT_ADDITIONAL_BRANCHES_FEE") {
                debtManagementAgencyFees.additionalBranchFees = fee.value
            } else if(fee.name === "DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION_FEE") {
                debtManagementAgencyFees.agentFees = fee.value
            } else if(fee.name === "DEBT_MANAGEMENT__INDIVIDUAL_RENEWAL_FEE") {
                debtManagementAgencyFees.agentRenewalFees = fee.value
            }
        })

        primaryApplication.referenceData?.feeMortgageDataList?.forEach(fee => {
            switch(fee.name) {
                case "MORTGAGE_BROKER_NEW_APPLICATION" :
                    mortgageAgencyFees.brokerFees = fee.value
                    break
                case "MORTGAGE_BROKER_RENEWAL" :
                    mortgageAgencyFees.brokerRenewalFees = fee.value
                    break
                case "ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION":
                    mortgageAgencyFees.associateBrokerFees = fee.value
                    break
                case "ASSOCIATE_MORTGAGE_BROKER_RENEWAL":
                    mortgageAgencyFees.associateBrokerRenewalFees = fee.value
                    break
                case "MORTGAGE_BROKERAGE_NEW_APPLICATION" : 
                    mortgageAgencyFees.brokerageFees = fee.value
                    break
                case "MORTGAGE_BROKERAGE_RENEWAL" : 
                    mortgageAgencyFees.brokerageRenewalFees = fee.value
                    break
                case "MORTGAGE_LENDER_NEW_APPLICATION" : 
                    mortgageAgencyFees.lenderFees = fee.value
                    break
                case "MORTGAGE_LENDER_RENEWAL" : 
                    mortgageAgencyFees.lenderRenewalFees = fee.value
                    break
                case "MORTGAGE_ADMINISTRATOR_NEW_APPLICATION" : 
                    mortgageAgencyFees.administratorFees = fee.value
                    break
                case "MORTGAGE_ADMINISTRATOR_RENEWAL" : 
                    mortgageAgencyFees.administratorRenewalFees = fee.value
                    break
                case "PRINCIPAL_BROKER_NEW_APPLICATION" : 
                    mortgageAgencyFees.principalBrokerFees = fee.value
                    break
                case "PRINCIPAL_BROKER_RENEWAL" : 
                    mortgageAgencyFees.principalBrokerRenewalFees = fee.value
                    break
                case "INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION":
                case "INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION":
                    mortgageMainAgentApplicationFees.brokerageFees = fee.value
                    break;
                case "INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION":
                case "INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION":
                    mortgageMainAgentApplicationFees.brokerageRetentionFees = fee.value
                    break;
                case "ASSOCIATE_MORTGAGE_BROKER_RETENTION_APPLICATION":
                    mortgageAgencyFees.associateBrokerTransferFees = fee.value
                    break;
                case "MORTGAGE_BROKER_RETENTION_APPLICATION":
                    mortgageAgencyFees.brokerTransferFees = fee.value
                    break;
                default : 
                    console.warn("unknown mortgage fees name : " + fee.name)
                    break
            }
        })

        return Object.assign({},
            components.paymentPreview,
            {
                primaryApplication :  primaryApplication.application,
                referenceData : primaryApplication.referenceData,  
                additionalBranchApplications : additionalApplications.additionalBranchApplications.filter(app => !app.markedDeleted),
                agentApplications : additionalApplications.agentApplications,
                agentData : additionalApplications.agentApplications,
                feesStructure : {
                    "collection-agency" : collectionAgencyFees,
                    "debt-management-agency" : debtManagementAgencyFees,
                    "mortgage-brokerage-licence" : mortgageAgencyFees,
                    "mortgage-main-agent" : mortgageMainAgentApplicationFees
                },
                paymentStatus : primaryApplication.paymentStatus
            }
        )
    }
)

export const paymentPreviewSelect = state => ({
    paymentPreview : paymentPreviewSelector(state)
})
